// extracted by mini-css-extract-plugin
export default {"intro":"ModalNuevoPagoAlumno_intro__Akm6V","input":"ModalNuevoPagoAlumno_input__i2id8"};